import { createStyles, makeStyles, Theme, Tooltip } from '@material-ui/core';
import DomainIcon from '@material-ui/icons/Domain';
import LockIcon from '@material-ui/icons/Lock';
import PeopleIcon from '@material-ui/icons/People';
import React from 'react';

export function PrivateVisibilityIcon(): React.ReactElement {
  const classes = useStyles();
  return (
    <Tooltip title="Visible only to you" classes={{ tooltip: classes.tooltip }}>
      <LockIcon />
    </Tooltip>
  );
}

export function TeamVisibilityIcon({ plexName }: { plexName: string }): React.ReactElement {
  const classes = useStyles();
  return (
    <Tooltip title={`Visible to members of "${plexName}"`} classes={{ tooltip: classes.tooltip }}>
      <PeopleIcon />
    </Tooltip>
  );
}

export function DomainVisibilityIcon(): React.ReactElement {
  const classes = useStyles();
  return (
    <Tooltip title={`Visible to users within the organization`} classes={{ tooltip: classes.tooltip }}>
      <DomainIcon />
    </Tooltip>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      fontSize: theme.typography.caption.fontSize,
    },
  })
);
